import { render, staticRenderFns } from "./basicsInfo.vue?vue&type=template&id=78553663&scoped=true&"
import script from "./basicsInfo.vue?vue&type=script&lang=ts&"
export * from "./basicsInfo.vue?vue&type=script&lang=ts&"
import style0 from "./basicsInfo.vue?vue&type=style&index=0&id=78553663&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78553663",
  null
  
)

export default component.exports